import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import Api from '../../../services/Api';

const ContextsTypeSelector = ({
  onChanged,
  isMulti,
  selectedId,
}) => {
  const [contexts, setContexts] = useState([]);

  useEffect(() => {
    Api.get('types/contexts?per_page=200').then((response) => {
      if (response.status === 200) {
        const mappedValues = response.data.data.map(product => ({
          label: `${product.name} [${product.code}]`,
          value: product.id,
        }));
        setContexts(mappedValues);
      }
    });
  }, []);
  let selectedItem;
  if (selectedId) {
    selectedItem = contexts.find(x => x.value === selectedId);
  }
  return (
    <Select
      isMulti={isMulti}
      options={contexts}
      value={selectedItem}
      onChange={(value) => {
        if (onChanged) {
          onChanged(value);
        }
      }}
      placeholder="Select Context Type"
    />
  );
};

ContextsTypeSelector.propTypes = {
  onChanged: PropTypes.func,
  isMulti: PropTypes.bool,
  selectedId: PropTypes.number,
};

ContextsTypeSelector.defaultProps = {
  onChanged: undefined,
  isMulti: false,
  selectedId: undefined,
};

export default ContextsTypeSelector;
